import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
} from '@angular/core'
import { Facet, GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { FacetService } from '../services/facet.service'
import {
  ICON_TYPE,
  FocusConfig,
  FacetList,
  FacetGroupCollapsedState,
} from '@spartacus/storefront'
import { Router, ActivatedRoute } from '@angular/router'
import { FacetComponent } from '../facet/facet.component'
import { CommonService } from '../../../../shared/services/common.service'

@Component({
  standalone: false,

  selector: 'cx-facet-list',
  templateUrl: './facet-list.component.html',
  styleUrls: ['./facet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetListComponent {
  // tslint:disable-next-line: variable-name
  private _isDialog: boolean
  params: any
  length: number
  /**
   * Indicates that the facet navigation is rendered in dialog.
   */
  @Input()
  set isDialog(value: boolean) {
    this._isDialog = value
    if (value) {
      this.renderer.addClass(document.body, 'modal-open')
    }
  }

  get isDialog(): boolean {
    return this._isDialog
  }

  /** Emits when the list must close */
  @Output() closeList = new EventEmitter()

  /** The list of all facet and values related to the products in the list */
  facetList$: Observable<FacetList> = this.facetService.facetList$

  iconTypes = ICON_TYPE

  dialogFocusConfig: FocusConfig = {
    trap: true,
    block: true,
    focusOnEscape: true,
    autofocus: 'cx-facet',
  }

  @HostListener('click') handleClick() {
    this.close()
  }

  catData$: Observable<any>
  isCategoryPage: false

  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    public router: Router,
    public routes: ActivatedRoute,
    private commonService: CommonService,
    private globalMessageService: GlobalMessageService
  ) {
    this.routes.params.subscribe(
      (success) => {
        this.params = success
        this.routes.params.subscribe(
          (params) => {
            this.params = params
            if (this.params?.categoryCode) {
              this.catData$ = this.getCategories()
            }
          },
          (error) => {
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.facetList$.subscribe((success) => {})

    const keys = Object.keys(this.params)
    this.length = keys.length
  }

  getCategories() {
    const urlParam = ['vsCategories', 'facets', this.params?.categoryCode]
    // /{baseSiteId}/vsCategories/facets/{categoryId}
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  /**
   * Toggles the facet group in case it is not expanded.
   */
  expandFacetGroup(facet: Facet, ref: FacetComponent) {
    if (!ref.isExpanded) {
      this.facetService.toggle(facet, ref.isExpanded)
    }
  }

  /**
   * Indicates that the facet group has been expanded.
   */
  isExpanded(facet: Facet): Observable<boolean> {
    return this.facetService
      .getState(facet)
      .pipe(map((value) => value.toggled === FacetGroupCollapsedState.EXPANDED))
  }

  /**
   * Indicates that the facet group has been collapsed.
   */
  isCollapsed(facet: Facet): Observable<boolean> {
    return this.facetService
      .getState(facet)
      .pipe(
        map((value) => value.toggled === FacetGroupCollapsedState.COLLAPSED)
      )
  }

  close(event?: boolean): void {
    this.renderer.removeClass(document.body, 'modal-open')
    this.closeList.emit(event)
  }

  block(event?: MouseEvent) {
    event.stopPropagation()
  }
}
